<footer class="main-footer">
  <div class="float-right hidden-xs">
    <span> <b>Versão</b> {{ webVersion }} </span>
    <span *ngIf="apiVersion"> <b>Server</b> {{ apiVersion.version }} </span>
    <strong
      class="environment-{{ environment.name }}"
      *ngIf="!environment.production"
    >
      <b>Environment</b> {{ environment.name | titlecase }}</strong
    >
  </div>
  <div class="text-copy">
    <!-- <strong
      >Todos os direitos reservados &copy; 2019 Sociedade Corretora Paulista
      S/A.</strong
    > -->

    <strong>Todos os direitos reservados &copy; 2021 </strong>
  </div>
</footer>
